<app-menu></app-menu>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-loading-spinner></app-loading-spinner>